
<!-- <div class="sm:mx-auto sm:w-full sm:max-w-7xl pt-20 pb-10 sticky top-0 bg-white z-10 px-4 sm:px-6 lg:px-8">
    <div class="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
      <h2 class="text-2xl sm:text-3xl leading-9 font-extrabold text-gray-900">
        Manage Users
      </h2>
      <div class="relative w-full sm:w-auto">
        <input
          type="text"
          placeholder="Search users"
          [(ngModel)]="searchQuery"
          (input)="filterUsers()"
          class="border border-gray-300 rounded-md py-2 pl-10 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 w-full sm:w-64"
        />
        <svg
          class="absolute left-2 top-2.5 h-5 w-5 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z"
          />
        </svg>
      </div>
    </div>
  </div> -->

  <div class="sm:mx-auto sm:w-full sm:max-w-7xl pt-5 pb-10 sticky top-0 bg-white z-10 px-4 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-7xl pt-20 pb-10 sticky top-0 bg-white z-10 px-4 sm:px-6 lg:px-8">
    <div class="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
      <h2 class="text-2xl sm:text-3xl leading-9 font-extrabold text-gray-900">
        Manage Users
      </h2>
      <div class="relative w-full sm:w-auto flex items-center space-x-2">
        <input
          type="text"
          placeholder="Search users"
          [(ngModel)]="searchQuery"
          (input)="filterUsers()"
          class="border border-gray-300 rounded-md py-2 pl-10 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 w-full sm:w-64"
        />
        <svg
          class="absolute left-2 top-2.5 h-5 w-5 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z"
          />
        </svg>
        <button
          (click)="toggleAddUser()"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Add User
        </button>
      </div>
    </div>
  </div>
  
  
  
  
  <div class="mt-12 sm:mx-auto sm:w-full sm:max-w-7xl">
    <ul role="list" class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4" >
      <li *ngFor="let user of filteredUsers" class="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white text-center shadow" style="border: 2px solid rgb(227, 227, 227);">
        <div class="flex flex-1 flex-col p-8">
          <div *ngIf="user.profilePicture; else noImage">
            <img class="mx-auto h-32 w-32 flex-shrink-0 rounded-full" [src]="user.profilePicture" alt="{{ user.name }}">
          </div>
          <ng-template #noImage>
            <div [ngClass]="namebkC(user)" class="mx-auto h-32 w-32 rounded-full flex items-center justify-center text-white font-bold text-2xl">
              {{ nameinitial(user) }}
            </div>
          </ng-template>
          <h3 class="mt-6 text-sm font-medium text-gray-900">{{ user.name }}</h3>
          <dl class="mt-1 flex flex-grow flex-col justify-between">
            <dt class="sr-only">Email</dt>
            <dd class="text-sm text-gray-500">{{ user.email }}</dd>
            <dt class="sr-only">Roles</dt>
            <dd class="mt-3">
              <span *ngFor="let role of user.roles" class="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                {{ role.name }}
              </span>
            </dd>
          </dl>
        </div>
        <div>
          <div class="-mt-px flex divide-x divide-gray-200">
            <div class="flex w-0 flex-1">
              <a (click)="resetPassword(user)" class="relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-gray-900 cursor-pointer">
                <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path d="M12.9 4.12c.38.38.38 1 0 1.38-.38.38-1 .38-1.38 0a3 3 0 00-4.24 4.24c.38.38.38 1 0 1.38-.38.38-1 .38-1.38 0a5 5 0 010-7.07c.38-.38 1-.38 1.38 0 .38.38.38 1 0 1.38-.38.38-.38 1 0 1.38a1 1 0 019 6c.38-.38.38-1 0-1.38-.38-.38-.38-1 0-1.38.38-.38 1-.38 1.38 0a5 5 0 011.77 1.77c.38.38 1 .38 1.38 0 .38-.38 1-.38 1.38 0z"/>
                </svg>
                Reset Password
              </a>
            </div>
            <div class="-ml-px flex w-0 flex-1">
              <a (click)="editUser(user)" class="relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-br-lg border border-transparent py-4 text-sm font-semibold text-gray-900 cursor-pointer">
                <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path d="M17.41 4.59a1 1 0 010 1.42l-10 10a1 1 0 01-.39.24l-3 1a1 1 0 01-1.28-1.28l1-3a1 1 0 01.24-.39l10-10a1 1 0 011.42 0zm-4.25 2.83L8 12.59 7.41 14l1.41-1.41 5.16-5.16zM16 6.41L13.59 4 16 1.59 18.41 4 16 6.41zM5 14.59L2.59 12 5 9.59 7.41 12 5 14.59zM8 2.59L10.41 5 8 7.41 5.59 5 8 2.59z"/>
                </svg>
                Edit User
              </a>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <div *ngIf="editUserVisible" @slideInOut class="fixed inset-y-0 right-0 flex max-w-full bg-white shadow-xl z-50 overflow-y-auto" style="top: 64px;">
    <div class="w-screen max-w-md">
      <div class="h-full flex flex-col bg-white shadow-xl">
        <div class="px-4 py-6 bg-gray-50 sm:px-6">
          <div class="flex items-start justify-between">
            <h2 class="text-xl font-medium text-gray-900">Edit User</h2>
            <div class="ml-3 h-7 flex items-center">
              <button (click)="toggleEditUser()" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500">
                <span class="sr-only">Close panel</span>
                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          <div class="mt-2 text-sm leading-6 text-gray-500">
            <div *ngIf="user?.profilePicture; else noImage1">
                <img class="mx-auto h-32 w-32 flex-shrink-0 rounded-full" [src]="user.profilePicture" alt="{{ user.name }}">
              </div>
              <ng-template #noImage1>
                <div [ngClass]="namebkC(selectedUser)" class="mx-auto h-32 w-32 rounded-full flex items-center justify-center text-white font-bold text-4xl">
                  {{ nameinitial(selectedUser) }}
                </div>
              </ng-template>
          </div>
        </div>
        <div class="px-4 py-4 sm:px-6">
          <form (ngSubmit)="saveUser()" #editUserForm="ngForm" class="space-y-6">
            <div>
              <label for="name" class="block text-sm font-medium text-gray-700">Name</label>
              <input type="text" id="name" name="name" [(ngModel)]="selectedUser!.name" required
                     class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
            </div>
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
              <input type="email" id="email" name="email" [(ngModel)]="selectedUser!.email" required
                     class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
            </div>
            <div>
              <label for="edit-role" class="block text-sm font-medium text-gray-700">Roles</label>
              <select id="edit-role" name="editRole" [(ngModel)]="selectedRoleId" required
                      class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
                <option value="" disabled>Select a role</option>
                <option *ngFor="let role of allRoles" [ngValue]="role._id">{{ role.name }}</option>
              </select>
            </div>
            <div class="flex items-center">
              <button type="submit"
                      class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Save Changes
              </button>
            </div>
          </form>
          <div class="flex items-center justify-between mt-4">
            <button (click)="resetPassword(selectedUser)"
                    class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-yellow-600 hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500">
              Reset Password
            </button>
          </div>
          <div class="flex items-center justify-between mt-4">
            <button (click)="deleteUser(selectedUser)"
                    class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
              Delete User
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="addUserVisible" @slideInOut class="fixed inset-y-0 right-0 flex max-w-full bg-white shadow-xl z-50 overflow-y-auto" style="top: 64px;">
    <div class="w-screen max-w-md">
      <div class="h-full flex flex-col bg-white shadow-xl">
        <div class="px-4 py-6 bg-gray-50 sm:px-6">
          <div class="flex items-start justify-between">
            <h2 class="text-xl font-medium text-gray-900">Add New User</h2>
            <div class="ml-3 h-7 flex items-center">
              <button (click)="toggleAddUser()" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500">
                <span class="sr-only">Close panel</span>
                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
         
        </div>
        <div class="px-4 py-4 sm:px-6">
          <form (ngSubmit)="addUser()" #addUserForm="ngForm" class="space-y-6">
            <div>
              <label for="name" class="block text-sm font-medium text-gray-700">Name</label>
              <input type="text" id="name" name="name" [(ngModel)]="newUser.name" required
                     class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
            </div>
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
              <input type="email" id="email" name="email" [(ngModel)]="newUser.email" required
                     class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
            </div>
            <div>
              <label for="password" class="block text-sm font-medium text-gray-700">Password</label>
              <div class="relative mt-1">
                <input [type]="showNewPassword ? 'text' : 'password'" id="password" name="password" [(ngModel)]="newUser.password" autocomplete="new-password" required
                       class="appearance-none rounded relative block w-full px-3 py-2 pr-10 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
                <button type="button" (click)="showNewPassword = !showNewPassword"
                        class="absolute inset-y-0 right-0 pr-3 flex items-center"
                        [attr.aria-label]="showNewPassword ? 'Hide password' : 'Show password'">
                  <svg *ngIf="!showNewPassword" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  <svg *ngIf="showNewPassword" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                  </svg>
                </button>
              </div>
              <ul class="mt-2 space-y-1 text-xs">
                <li [class.text-green-700]="passwordPolicy.length" [class.text-gray-500]="!passwordPolicy.length">At least 8 characters</li>
                <li [class.text-green-700]="passwordPolicy.letter" [class.text-gray-500]="!passwordPolicy.letter">At least one letter</li>
                <li [class.text-green-700]="passwordPolicy.number" [class.text-gray-500]="!passwordPolicy.number">At least one number</li>
              </ul>
              <p *ngIf="passwordPolicy.valid" class="mt-2 text-xs font-medium text-green-700">Password meets the security policy.</p>
            </div>
            <div>
              <label for="add-role" class="block text-sm font-medium text-gray-700">Roles</label>
              <select id="add-role" name="addRole" [(ngModel)]="newRoleId" required
                      class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
                      <option value="" disabled>Select a role</option>
                      <option *ngFor="let role of allRoles" [ngValue]="role._id">{{ role.name }}</option>
              </select>
            </div>
            
            <div class="flex items-center">
              <p *ngIf="addUserError" class="text-sm text-red-600">{{ addUserError }}</p>
              <button type="submit" [disabled]="!passwordPolicy.valid"
                      class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-300 disabled:cursor-not-allowed">
                Add User
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="addConflict" class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 px-4">
    <div class="w-full max-w-md rounded-lg bg-white p-6 shadow-xl" role="dialog" aria-labelledby="existing-user-title">
      <h3 id="existing-user-title" class="text-lg font-medium text-gray-900">
        {{ addConflict.code === 'removed' ? 'Add this person back?' : 'Transfer this person?' }}
      </h3>
      <p *ngIf="addConflict.code === 'removed'" class="mt-2 text-sm text-gray-600">
        {{ addConflict.name }} was removed from this shop. Add them back with this role and password?
      </p>
      <p *ngIf="addConflict.code === 'other-shop'" class="mt-2 text-sm text-gray-600">
        {{ addConflict.name }} already works at {{ addConflict.shopName }}. Transfer them to this shop? They will leave that team.
      </p>
      <div class="mt-4 flex gap-2">
        <button type="button" (click)="cancelExistingUser()"
                class="w-full rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
          Cancel
        </button>
        <button type="button" (click)="confirmExistingUser()"
                class="w-full rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-500">
          {{ addConflict.code === 'removed' ? 'Add back' : 'Transfer' }}
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="createdPassword" class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 px-4">
    <div class="w-full max-w-md rounded-lg bg-white p-6 shadow-xl" role="dialog" aria-labelledby="created-user-title">
      <h3 id="created-user-title" class="text-lg font-medium text-gray-900">{{ createdTitle }}</h3>
      <p class="mt-2 text-sm text-gray-600">{{ createdNotice }}</p>
      <div class="mt-4 flex items-center gap-2">
        <code class="min-w-0 flex-1 break-all rounded-md bg-gray-100 px-3 py-2 text-sm text-gray-900">{{ createdPassword }}</code>
        <button type="button" (click)="copyCreatedPassword()" aria-label="Copy password"
                class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50">
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
        </button>
      </div>
      <p *ngIf="passwordCopied" class="mt-2 text-xs font-medium text-green-700">Copied to clipboard.</p>
      <button type="button" (click)="dismissCreatedPassword()"
              class="mt-4 w-full rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-500">
        Done
      </button>
    </div>
  </div>
  